import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const FormsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
FormsViewTopBar.displayName = "FormsViewTopBar"
